import { Component, OnInit } from '@angular/core';
import { EaccessAuthService } from '../auth/eaccess-auth.service';
import { ROLE_COMPLIANCE } from '../shared/constants';

@Component({
  selector: 'eaa-can-write-motds',
  template: `
    @if (canWrite) {
      <ng-content></ng-content>
    }
  `
})
export class CanWriteMotdsComponent implements OnInit {
  public canWrite: boolean | null = null;

  constructor(private authService: EaccessAuthService) {}

  public ngOnInit(): void {
    this.authService.hasRole$(ROLE_COMPLIANCE).subscribe((hasRole) => (this.canWrite = hasRole));
  }
}
